import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { useGrowIconButtonStyles } from '@mui-treasury/styles/iconButton/grow';
import { useSizedIconButtonStyles } from '@mui-treasury/styles/iconButton/sized';

import { UpdatSelectedMaxLevelAsset } from '../../../actions/learningcontent-actions'

const ExtraMaxLevelAssetModal = ({ _isOpen, _notiCloseClick, _extraContent }) => {

    const largeStyles = useSizedIconButtonStyles({ childSize: 64, padding: 12 });
    const customGrowStyles = useGrowIconButtonStyles({ color: '#0492C2', thickness: 6 });
    const [choice, setChoice] = useState('');

    const confirmChoice = async () => {
        //submit selected choice;
        if (choice.length < 1)
            return;
        else {
            //console.log(`Choice you made ${choice}, student Number:${_extraContent.studentNumber}, traitGroupId:${_extraContent.traitGroupId}`);
            await UpdatSelectedMaxLevelAsset(_extraContent.traitGroupId, _extraContent.studentNumber, choice)
            _notiCloseClick();
        }

    }

    return (
        <>
            {
                _isOpen ?
                    <>
                        <Dialog fullWidth={true}
                            maxWidth={'md'}
                            open={_isOpen}>
                            <DialogContent>
                                <div className="completedsurvey__root" width="400px">
                                    <CardContent>
                                        <Grid
                                            container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <Grid
                                                container
                                                direction="column"
                                                justify="space-around"
                                                alignItems="center">
                                                <Typography className="adventurelearn__header" style={{ color: '#0492C2' }}>
                                                    Congratulations!
                                                </Typography>
                                                <Typography className="adventurelearn__tandcContent">
                                                    You are such an extraordinary student for achieving a trait score beyond max level!
                                                </Typography>
                                                <div style={{ display: 'flex' }}>
                                                    <IconButton
                                                        onClick={() => setChoice("Ship")}
                                                        style={{ marginRight: '10px' }}
                                                        classes={largeStyles}
                                                        className={customGrowStyles.root}
                                                        disableTouchRipple
                                                    >
                                                        <img
                                                            style={{ width: '130px', height: '130px' }}
                                                            alt={''}
                                                            src={
                                                                "./assets/images/components/island/particle/ship.png"
                                                            }
                                                        />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => setChoice("Dolphin")}
                                                        style={{ marginLeft: '10px' }}
                                                        classes={largeStyles}
                                                        className={customGrowStyles.root}
                                                        disableTouchRipple
                                                    >
                                                        <img
                                                            style={{ width: '130px', height: '130px' }}
                                                            alt={''}
                                                            src={
                                                                "./assets/images/components/island/particle/dolphin.png"
                                                            }
                                                        />
                                                    </IconButton>
                                                </div>
                                                <Typography className="adventurelearn__tandcContent">
                                                    Please choose one item to be added to the sea as a compliment of your achievement
                                                </Typography>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justify="space-evenly"
                                                    alignItems="flex-start">
                                                    <Button variant={'outlined'} onClick={() => confirmChoice()} className="adventurelearn__dialogOk">
                                                        Confirm
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </>
                    :
                    <></>
            }
        </>
    );
}

export { ExtraMaxLevelAssetModal as default }